import React from 'react';
import './App.css';
import Header from './components/Header';
import Hero from './components/Hero';
import About from './components/About';
import Tools from './components/Tools';
import PortfolioSection from './components/PortfolioSection';
import Contact from './components/Contact';
import Footer from './components/Footer';

function App() {
  const portfolioItems = [
    {
      id: 1,
      title: 'AI Response Evaluation Sample',
      description: 'Rank and score AI customer service responses with systematic evaluation. Identifies empathy gaps, missing action items, and unclear timelines.',
      file: '1_AI_Response_Evaluation_Sample.html'
    },
    {
      id: 2,
      title: 'Chain-of-Thought Review Example',
      description: 'Evaluate AI reasoning processes step-by-step. Identifies logical gaps, missing analysis, and incomplete frameworks.',
      file: '2_Chain_of_Thought_Review_Example.html'
    },
    {
      id: 3,
      title: 'Edited/Improved AI Output',
      description: 'Transform generic AI content into professional, actionable outputs. Before/after comparison showing 25% readability improvement.',
      file: '3_Edited_Improved_AI_Output.html'
    },
    {
      id: 4,
      title: 'Data Entry/Categorization Sample',
      description: 'Systematic categorization with 99%+ accuracy. 50 products across multiple dimensions with consistent formatting.',
      file: '4_Data_Entry_Categorization_Sample.html'
    },
    {
      id: 5,
      title: 'AI Evaluator Portfolio',
      description: 'Complete skills overview. Tools, methodologies, and proven results that improve model performance by 20-30%.',
      file: '5_AI_Evaluator_Portfolio.html'
    },
    {
      id: 6,
      title: 'Writing Samples',
      description: 'Clear, natural English across contexts. Customer support, technical explanations, and professional communications.',
      file: '6_Writing_Samples.html'
    },
    {
      id: 7,
      title: 'Prompt Crafting Examples',
      description: 'Effective prompt engineering that improves output quality 3x. Weak vs. strong prompt comparisons with actionable frameworks.',
      file: '7_Prompt_Crafting_Examples.html'
    }
  ];

  return (
    <div className="App">
      <Header />
      <Hero />
      <About />
      <Tools />
      <PortfolioSection items={portfolioItems} />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;

